import React from 'react';
import { Drawer } from 'antd';
import { SIDE_NAV_PROPERTY, SIDE_NAV_TRANSITION_CURVE } from '../hooks/useSideNavExpanded';

type Props = {
  open: boolean;
  style?: React.CSSProperties;
  children: React.ReactNode;
};

const ActionBar = ({ open = false, style = {}, children }: Props) => (
  <Drawer
    placement="bottom"
    closable={false}
    mask={false}
    open={open}
    size={52}
    rootStyle={{
      position: 'fixed',
      left: `var(${SIDE_NAV_PROPERTY})`,
      transition: `left ${SIDE_NAV_TRANSITION_CURVE}`,
      ...style,
    }}
    styles={{ body: { padding: '11px', background: '#545A6A' } }}
    getContainer={false}
    destroyOnHidden
  >
    {children}
  </Drawer>
);

export default ActionBar;
